module.exports = __webpack_public_path__ + "img/P19-zh.204ed1c9.png";